module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.perfilUsuario === 'recursos humanos') ? _c('span', [_vm._v("Solicitudes de vacaciones")]) : _c('span', [_vm._v("Solicitudes de vacaciones de mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret",
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [(_vm.perfilUsuario === 'recursos humanos') ? _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroEstado),
      expression: "filtroEstado"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroEstado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.estados), function(value, key) {
    return _c('option', {
      domProps: {
        "value": +key
      }
    }, [_vm._v(_vm._s(value.descripcion))])
  })], 2)])]) : _vm._e(), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarEmpleado
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroMes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.codigo === 'all' ? 'Todos' : o.descripcion))])
  }), 0)])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Año")]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroYear),
      expression: "filtroYear"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.years), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o === 'all' ? 'Todos' : o))])
  }), 0)])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    key: "body-scroll",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.mostrarConfirmacionNoLoTomo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNoLoTomo",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionNoLoTomo = false
      },
      "do": _vm.noLoTomo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea indicar que la solicitud no se tomó?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])] : [_c('span', [_vm._v("No lo tomó")])]], 2)])], 1) : _vm._e()], 1), (_vm.solicitudes.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Reemplazante")]), (_vm.perfilUsuario === 'recursos humanos') ? _c('th', {
    staticClass: "hide-break-2"
  }) : _vm._e()]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o) {
    return _c('tr', {
      key: o.id,
      staticClass: "row-table",
      class: {
        'is-close': !o.abierto
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), (o.desde !== o.hasta) ? [_c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])] : _vm._e()], 2), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "dias"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "dias"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('td', [(o.codigoEmpleadoReemplazante) ? [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniReemplazante
      }
    }, [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])] : [_c('span', [_vm._v("No definido")])], (_vm.perfilUsuario === 'recursos humanos') ? _c('div', {
      staticClass: "contenedor-acciones show-break-2"
    }, [(o.estado === 3) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarNoLoTomo(o)
        }
      }
    }, [_c('span', [_vm._v("No lo tomó")])]) : _vm._e()]) : _vm._e()], 2), (_vm.perfilUsuario === 'recursos humanos') ? _c('td', {
      staticClass: "hide-break-2"
    }, [(o.estado === 3) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarNoLoTomo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("No lo tomó")])]) : _vm._e()]) : _vm._e()])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e(), (_vm.solicitudes.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay solicitudes de vacaciones que cumplan con los siguientes filtros")])])]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-544249e8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Reporte_Lista_Solicitud_Vacaciones.vue
// module id = 882
// module chunks = 0